import { Country } from '../../constants'

const supportedCountries = [Country.US, Country.DE]

export const isCountrySupported = (country?: string) => supportedCountries.includes(country?.trim().toUpperCase() as Country)
